<script setup lang="ts">
import { getLangText } from '@/ts/utils/utils.ts';
import SportBettingIcon from "./assets/sport-betting.svg?raw";
import { navigateTo } from '@/ts/management/view-navigation-management';
import model from '@/ts/model';
import { isNavViewItemActive } from './mobile-nav-bottom';
</script>

<template>
    <div class="nav-item" @click.prevent.stop="navigateTo('sport-betting')" :class="{active: isNavViewItemActive('sport-betting')}">
        <div class="icon">
            <span v-html="SportBettingIcon"></span>
        </div>
        <div class="name">{{ getLangText('SportBettingShort', undefined, 'mobile-nav-bottom') }}</div>
    </div>
</template>

<style lang="scss" scoped>
@use './nav-item.scss';
</style>